<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      title="Job Description"
      text="Edit Job Description"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="description.value"
                v-validate="'required|max:1000'"
                :rows="5"
                :error-messages="errors.collect('value')"
                data-vv-name="value"     
                data-vv-as="description"           
                label="Description"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="tagIds"
                :items="tags"          
                label="Tags"
                placeholder="Job Description Tags"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-selected
                multiple
                chips
                deletable-chips
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      jobDescription: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        loading: false,
        progressing: false,
        description: {},
        tags: [],
        tagIds: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.description = { ...this.jobDescription }

          this.loadData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            Promise.all([
              this.$api.jobDescriptions().update(this.description.id, { value: this.description.value }),
              this.$api.jobDescriptionTags().update(this.description.id, this.tagIds),
            ])
              .then(([jobDescription, tags]) => {
                this.$emit('updated')
                this.$snack({ message: jobDescription.data.status })

                this.dialog = false
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      loadData () {
        this.loading = true
      
        Promise.all([
          this.$api.tags().list(),
          this.$api.jobDescriptionTags().list(this.jobDescription.id),
        ])
          .then(([tags, descriptionTags]) => {
            this.tags = tags.data
            this.tagIds = descriptionTags.data.map(tag => {
              return tag.id
            })

            this.loading = false
          })
      },
    },
  }
</script>
